"use strict";

var _createForOfIteratorHelper = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var insert_text_textarea_1 = __importDefault(require("insert-text-textarea"));

function indentTextarea(el) {
  var selectionStart = el.selectionStart,
      selectionEnd = el.selectionEnd,
      value = el.value;
  var linesCount = value.slice(selectionStart, selectionEnd).match(/^|\n/g).length;

  if (linesCount > 1) {
    // Select full first line to replace everything at once
    var firstLineStart = value.lastIndexOf('\n', selectionStart) + 1;
    el.setSelectionRange(firstLineStart, selectionEnd);
    var newSelection = el.value.slice(firstLineStart, selectionEnd);
    var indentedText = newSelection.replace(/^|\n/g, // Match all line starts
    '$&\t'); // Replace newSelection with indentedText

    insert_text_textarea_1.default(el, indentedText); // Restore selection position, including the indentation

    el.setSelectionRange(selectionStart + 1, selectionEnd + linesCount);
  } else {
    insert_text_textarea_1.default(el, '\t');
  }
}

function watchListener(event) {
  var tsEvent = event; // TODO: find a way around this ugly TypeScript workaround

  if (tsEvent.key === 'Tab' && !tsEvent.shiftKey) {
    indentTextarea(tsEvent.target);
    tsEvent.preventDefault();
  }
}

function watchAndIndent(elements) {
  if (typeof elements === 'string') {
    elements = document.querySelectorAll(elements);
  } else if (elements instanceof HTMLTextAreaElement) {
    elements = [elements];
  }

  var _iterator = _createForOfIteratorHelper(elements),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var element = _step.value;
      element.addEventListener('keydown', watchListener);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

indentTextarea.watch = watchAndIndent;
module.exports = indentTextarea;